import type { ReactNode } from 'react'
import { NavLink } from 'react-router'
import { IkonaKalendarz, IkonaKoszty, IkonaPulpit, IkonaWiecej } from './Ikony.js'
import './nawigacja.css'

interface Pozycja {
  do: string
  etykieta: string
  ikona: ReactNode
}

const POZYCJE: Pozycja[] = [
  { do: '/', etykieta: 'Pulpit', ikona: <IkonaPulpit /> },
  { do: '/kalendarz', etykieta: 'Kalendarz', ikona: <IkonaKalendarz /> },
  { do: '/koszty', etykieta: 'Koszty', ikona: <IkonaKoszty /> },
  { do: '/wiecej', etykieta: 'Więcej', ikona: <IkonaWiecej /> },
]

/**
 * Jedna nawigacja dla wszystkich rozmiarów: na telefonie renderuje się jako
 * pasek dolny w zasięgu kciuka, na pulpicie jako boczna szyna. O układzie
 * decyduje CSS, więc nie ma podwójnego drzewa DOM ani skoku przy zmianie okna.
 */
export function Nawigacja() {
  return (
    <nav className="nawigacja" aria-label="Główna">
      <p className="nawigacja__marka" aria-hidden="true">
        Budżet<span>firmy</span>
      </p>
      <ul className="nawigacja__lista">
        {POZYCJE.map((pozycja) => (
          <li key={pozycja.do}>
            <NavLink
              to={pozycja.do}
              end={pozycja.do === '/'}
              className={({ isActive }) =>
                isActive ? 'nawigacja__link nawigacja__link--aktywny' : 'nawigacja__link'
              }
            >
              {pozycja.ikona}
              <span>{pozycja.etykieta}</span>
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  )
}
